<template>
  <i class="ms-Icon" :class="['ms-Icon', className]" aria-hidden="true"></i>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    }
  },
  computed: {
    className() {
      return (
        'ms-Icon--' +
        this.name
          .split('-')
          .map(([first, ...rest]) => [first.toUpperCase(), ...rest].join(''))
          .join('')
      );
    }
  }
};
</script>
